import { emptyingDetectionsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("emptying-detection"),
  endpoint: "emptying-detections",
  operations: emptyingDetectionsOps,
  roleView: [ROLE.EMZ_DEVELOPER],
  roleAdmin: [ROLE.EMZ_DEVELOPER],
  singularName: (t) => t("Emptying Detection"),
  name: (t) => t("Emptying Detection"),
});
export default conf;
